export default __webpack_public_path__ + "media/components/AdEdit/images/vk-promo-menu-dd714125ae6868404e442a12b7d16faf.png";